export const PERF_REVIEW_TEAM_TYPE = 'org_performance_review_team';

export const ALL_SPECIAL_TEAM_TYPES = new Set([PERF_REVIEW_TEAM_TYPE]);